import './products.scss'
import _ from 'lodash'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {config} from '../../config'
import axios from 'axios'
import Sidebar from '../../components/sidebar/Sidebar'
import Header from '../../components/headerbar/Header'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { weightRangeOptionsData } from '../../constants'

const AddProducts = () => {
  const navigate = useNavigate()
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [productStyles, setproductStyles] = useState(null)
  const [productName, setProductName] = useState('')
  const [wastages, setWastages] = useState(null)
  const [weightrangeData, setWeightRangeData] = useState([])
  const [metalRateOptions, setMetalRateOptions] = useState([])
  const [weightRange, setWeightRange] = useState(null)
  const [weightRangeOptions, setWeightRangeOptions] = useState(
    []
  )
  const [currentWeightRange, setCurrentWeightRange] = useState(null)
  const [category_id, setCategory] = useState('')
  const [productType, setProductType] = useState('existing')
  const [productstyle, setProductStyle] = useState('')
  // const [wastage, setWastage] = useState("");

  const [skuid, setSkuid] = useState('')
  // const [product, setProduct] = useState("");
  const [remark, setRemark] = useState('')
  // const [weight, setWeight] = useState("");
  // const [carrot, setCarrot] = useState("");
  const [image, setImage] = useState('')
  const [price, setPrice] = useState(0)
  const [subCategory_id, setSubCategory_id] = useState('')
  const [rate, setRate] = useState('')
  const [currentRate, setCurrentRate] = useState(0)
  const [imagepreview, setImagepreview] = useState('')
  const [imagesUpload, setImagesUpload] = useState(null)
  const [imagede, setImagede] = useState('')
  const [updateid, setUpdateid] = useState('')
  const [error, setError] = useState(false)
  const [mainCategoryParam, setMainCategoryParam] = useState('')
  const [mainSubCategoryParam, setMainSubCategoryParam] = useState('')
  const [description, setDescription] = useState('')

  useEffect(() => {
    getCategory()
    getWeightRange()
    getRateData()
    // getproductStyles();
    getWastageData()
    // getSubCategory();
  }, [])
  ///////////////////// GET CATEGORY ///////////////////////////////
  const getCategory = async () => {
    let catresult = await fetch(config.apiurl + '/category/getcategory')
    catresult = await catresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setCategories(catresult?.data?.results)
  }

  //////////////// GET WEIGHTRANGE DATA ////////////////
  const getWeightRange = async () => {
    let weightrangelist = await fetch(config.apiurl + '/weightrange/')
    weightrangelist = await weightrangelist.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    const wwightRangeWithCheckedState = weightrangelist?.data?.results?.map(
      (data) => ({ ...data, checked: false, price: 0 })
    )
    setWeightRangeOptions(wwightRangeWithCheckedState)  
    setWeightRangeData(wwightRangeWithCheckedState)
  }
  ////////////////////////// GET RATE ////////////////////
  const getRateData = async () => {
    axios
      .get(config.apiurl + '/rates/getrate', {
        headers: {
          Authorization: 'Bearer ' + accesstoken.data.access_token,
        },
      })
      .then((res) => {
        setMetalRateOptions(res?.data?.data)
      })
      .catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", }))
  }

  // };

  const getSubCategory = async () => {
    let subactresult = await fetch(
      config.apiurl + `/subcategory/${mainCategoryParam}`,
      {
        method: 'get',
        headers: {
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
    )
    subactresult = await subactresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setSubCategories(subactresult?.data)
  }

  const getWastageData = async () => {
    let wastagelist = await fetch(config.apiurl + `/wastages/`, {
      method: 'get',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    wastagelist = await wastagelist.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setWastages(wastagelist?.data?.results)
  }

  const getproductStyles = async () => {
    let productStyleslist = await fetch(
      config.apiurl + `/prostyle/bySubCatgory/sub/${mainSubCategoryParam}`,
      {
        method: 'get',
        headers: {
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
    )
    productStyleslist = await productStyleslist
      .json()
      .catch((err) =>
        toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {
          type: "error",
        })
      );
    setproductStyles(productStyleslist?.data?.results)
  }
  useEffect(() => {
    !_.isEmpty(mainCategoryParam) && getSubCategory()
  }, [mainCategoryParam])

  useEffect(() => {
    !_.isEmpty(mainSubCategoryParam) && getproductStyles()
  }, [mainSubCategoryParam])

  const handlecategory = async (event) => {
    setCategory(event.target.value)
    setMainCategoryParam(event?.target?.value)
    setSubCategory_id('')
  }

  const handleSubCategory = async (event) => {
    setSubCategory_id(event.target.value)
    setMainSubCategoryParam(event.target.value)
    setProductStyle('')
    setProductName("")
  }

  const handleproductStyles = async (event) => {
    setProductStyle(event.target.value);
    // console.log("e: ", event.target.value, );
    setProductName(productStyles.find((productStyle) => productStyle._id === event.target.value)?.name || "");
  }

  // const handleWastgeDatalist = async (event) => {
  //   setWastage(event?.target?.value);
  // };
  // useEffect(() => {
  //   setWeightRangeData(weightRange)
  // }, [])

  // Weight range checkbox onchange
  // const handleweightRange = async (id, checkedState, weightValue) => {
  //   // Price calculation
  //   if (!_.isEmpty(rate) && !_.isEmpty(productstyle) && weightValue) {
  //     const currentRate = metalRateOptions?.find(
  //       (data) => data?._id === rate
  //     )?.rate
  //     const findProductStyle = productStyles?.find(
  //       (data) => data?._id === productstyle
  //     )
  //     const currentWastage =
  //       findProductStyle &&
  //       wastages?.find((data) => data?._id === findProductStyle?.wastage?._id)
  //     const currentWeight = weightrangeData?.find((data) => data?._id === id)
  //     if (currentRate && currentWastage && currentWeight?.value) {
  //       const currentWastagePercentRate =
  //         (currentRate / 100) * parseFloat(currentWastage?.wastage)
  //       const calculatedPrice =
  //         currentRate * currentWeight?.value + currentWastagePercentRate
  //       const updatedArr = weightrangeData?.map((data) =>
  //         data?._id === id
  //           ? {
  //               ...data,
  //               checked: !checkedState,
  //               price: checkedState ? 0 : calculatedPrice,
  //             }
  //           : { ...data }
  //       )
  //       setWeightRangeData(updatedArr)
  //     }
  //   }
  // }

  const handleWeightRange = async (event) => {
    setWeightRange(event.target.value)
    const weightRange = weightRangeOptions?.find(
      (data) => data?._id === event?.target?.value
    )
    weightRange
      ? setCurrentWeightRange(weightRange)
      : setCurrentWeightRange(null)
  }

  // const handleweightRange = async (value) => {
  //   setWeightRange(value);
  // };

  const handleRateData = async (event) => {
    setRate(event.target.value)
    const metalRate = metalRateOptions?.find(
      (data) => data?._id === event.target.value
    )
    metalRate ? setCurrentRate(metalRate?.rate) : setCurrentRate(0)
  }

  const handleImageupload = (event) => {
    const files = event.target.files

    if (files.length > 6) {
      toast(`Image exceeds the maximum limit. Please select less than six images.`, { type: "info" });
      return;
    }
    setImagesUpload([...files])
    const imagesArray = []

    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader()

      reader.onload = (e) => {
        imagesArray.push(e.target.result)
        if (imagesArray.length === files.length) {
          setImagepreview([...imagesArray])
        }
      }

      reader.readAsDataURL(files[i])
    }
  }

  const Transformfile = (files) => {
    const reader = new FileReader()
    if (files) {
      reader.readAsDataURL(files)
      reader.onloadend = () => {
        setImage(files.name)
        setImagepreview(reader.result)
        setImagede(files)
      }
    } else {
      setImage('')
      setImagepreview('')
      setImagede('')
    }
  }

  const submitProductDetails = async (images) => {
    const editupdateurl = config.apiurl + '/product/'
    const configdata = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const ondataSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        toast('Product Added successfully')
        setTimeout(() => {
          navigate('/product')
        }, 2000)
      } 
    }
    const ondataFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    const editdata = {
      category_id: category_id,
      subCategory_id: subCategory_id,
      productstyle: productstyle,
      name: productName,
      // remark: remark,
      weightRange: currentWeightRange?._id || "",
      // wastage: wastage,
      // weightRanges: weightrangeData,
      weightRanges: currentWeightRange?.options || [],
      skuid: skuid,
      rate: rate,
      productType: productType,

      // product: product,
      image: images,
      price: price,
      description: description,
    }
    axios
      .post(editupdateurl, editdata, configdata)
      .then(ondataSuccess, ondataFailure)
  }

  const handleProsubmit = async () => {
    if (
      !category_id ||
      !subCategory_id ||
      !productstyle||
      !productName?.trim() ||
      // !currentWeightRange ||
      !productType?.trim()  ||
      !rate ||
      !description || 
      !imagepreview
    ) {
      setError(true)
      return false
    }

    const imageApiUrl = config.apiurl + '/upload/upload-multiple'
    const configimg = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const formData = new FormData()
    imagesUpload?.map((file) => formData.append('files', file))
    // formData.append("files", imagede);

    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        submitProductDetails(res?.data?.data)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.post(imageApiUrl, formData, configimg).then(onSuccess, onFailure)
  }

  // Set current rate based on main category
  useEffect(() => {
    if (!_.isEmpty(category_id)) {
      const findMetalRate = metalRateOptions?.find(
        (data) => data?.category?._id === category_id
      )

      findMetalRate && setRate(findMetalRate?._id)
      findMetalRate && setCurrentRate(findMetalRate?.rate)
    }
  }, [category_id, metalRateOptions])

  // Set Price based on current rate
  // useEffect(() => {
  //   if (
  //     !_.isEmpty(rate) &&
  //     !_.isEmpty(productstyle) &&
  //     !_.isEmpty(weightRange)
  //   ) {
  //     const currentRate = metalRateOptions?.find(
  //       (data) => data?._id === rate
  //     )?.rate;
  //     const findProductStyle = productStyles?.find(
  //       (data) => data?._id === productstyle
  //     );
  //     const currentWastage =
  //       findProductStyle &&
  //       wastages?.find((data) => data?._id === findProductStyle?.wastage?._id);
  //     const currentWeight = weightrangeData?.find(
  //       (data) => data?._id === weightRange
  //     );
  //     if (currentRate && currentWastage && currentWeight?.value) {
  //       const currentWastagePercentRate =
  //         (currentRate / 100) * parseFloat(currentWastage?.wastage);
  //       console.log(currentWastagePercentRate);
  //       const calculatePrice =
  //         currentRate * currentWeight?.value + currentWastagePercentRate;
  //       calculatePrice && setPrice(parseFloat(calculatePrice));
  //     }
  //   }
  // }, [
  //   rate,
  //   weightRange,
  //   metalRateOptions,
  //   wastages,
  //   productstyle,
  //   productStyles,
  //   weightrangeData,
  // ]);

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Add Product Upload</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          data-required="true"
                          for="files"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Image
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={(event) => handleImageupload(event)}
                          multiple
                        />
                        <span className="text-danger text-gradient text-xs text-secondary">
                          Note:
                        </span>{" "}
                        <span className="text-dark text-gradient text-xs text-secondary">
                          Select single or multiple images (Maximum - 6 Images)
                        </span>
                        <br />
                        {error && !imagepreview && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the image
                          </span>
                        )}
                      </div>
                    </div>
                    {!_.isEmpty(imagepreview) && (
                      <div className="col-md-6 imageWrapper">
                        {imagepreview?.map((data) => (
                          <div>
                            <img
                              src={
                                data?.startsWith("data")
                                  ? data
                                  : config?.fileurl + data
                              }
                              alt="Product Img"
                              width="150"
                              height="150"
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Category
                        </label>
                        <select
                          className="form-control"
                          value={category_id}
                          onChange={(event) => {
                            handlecategory(event);
                            setSubCategory_id("");
                          }}
                        >
                          <option value={""}> Choose </option>
                          {categories.map((item, index) => (
                            <option value={item._id}>{item.name}</option>
                          ))}
                        </select>
                        {error && !category_id && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the category name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Product
                        </label>
                        <select
                          className="form-control"
                          value={subCategory_id}
                          onChange={(event) => handleSubCategory(event)}
                        >
                          <option value={""}> Choose </option>
                          {subCategories &&
                            subCategories.map((item, index) => (
                              <option value={item._id}>{item.name}</option>
                            ))}
                        </select>
                        {error && !subCategory_id && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the product name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Sub Product
                        </label>
                        <select
                          className="form-control"
                          value={productstyle}
                          onChange={(event) => handleproductStyles(event)}
                        >
                          <option value={""}> Choose </option>
                          {productStyles &&
                            productStyles.length &&
                            productStyles.map((item, index) => (
                              <option key={item._id} value={item?._id}>
                                {item.name}
                              </option>
                            ))}
                        </select>
                        {error && !productstyle && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the sub product name
                          </span>
                        )}
                      </div>
                    </div>

                    {/* <div className="col-md-12"> */}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Product Type
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={productName}
                          onChange={(e) => {
                            setProductName(e.target.value);
                          }}
                        />
                        {error && !productName?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the product Type
                          </span>
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {/* Weight range options */}
                    <div className="col-md-12">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label
                            htmlFor="example-text-input"
                            className="form-control-label"
                          >
                            Select weight range
                          </label>
                          <select
                            className="form-control"
                            value={weightRange}
                            onChange={(event) => handleWeightRange(event)}
                            disabled={_.isEmpty(rate)}
                          >
                            <option value={""}> Choose </option>
                            {!_.isEmpty(weightRangeOptions) &&
                              weightRangeOptions.map((item, index) => (
                                <option key={item._id} value={item?._id}>
                                  {item.range}
                                </option>
                              ))}
                          </select>
                          {/* {error && !weightRange && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              Choose the weight range
                            </span>
                          )} */}
                        </div>
                      </div>
                    </div>

                    {/* Weight range prices */}
                    {/* {!_.isEmpty(currentWeightRange) && (
                      <div className="col-md-12">
                        <div className="col-md-3">
                          <label data-required="true"
                            htmlFor="example-text-input"
                            className="form-control-label"
                          >
                            Weight range prices
                          </label>

                          <section className={'rangePriceWrapper'}>
                            {!_.isEmpty(currentWeightRange?.options) &&
                              currentWeightRange?.options?.map((data) => (
                                <p>
                                  {data?.value}g &nbsp;&nbsp; - &#x20b9;{' '}
                                  {currentRate * data?.value}{' '}
                                </p>
                              ))}
                          </section>
                        </div>
                      </div>
                    )} */}

                    {/* <div className="container">
                      <form className="form ">
                        <h6>
                          Select Weight Range (
                          <span className="weightRangeCaption">
                            &nbsp; *select category , product , subProduct to
                            calculate weight rage price &nbsp;
                          </span>
                          ){' '}
                        </h6>
                        <div className="form-check"></div>
                        {weightrangeData &&
                          weightrangeData.length &&
                          weightrangeData.map((data, index) => (
                            <div className="col-md-12 weightRangeWrapper">
                              <div className=" form-check" key={index}>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name={data.range}
                                  value={data?.checked}
                                  checked={data?.checked}
                                  onChange={(e) =>
                                    handleweightRange(
                                      data?._id,
                                      data?.checked,
                                      data?.value
                                    )
                                  }
                                  disabled={
                                    _.isEmpty(rate) ||
                                    _.isEmpty(category_id) ||
                                    _.isEmpty(subCategory_id) ||
                                    _.isEmpty(productstyle)
                                  }
                                />
                                <label data-required="true" className="form-check-label ms-2">
                                  {data.range}
                                </label>
                              </div>
                              <div>
                                <p>price ( &#8377; {data?.price} )</p>
                              </div>
                            </div>
                          ))}
                      </form>
                    </div> */}

                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Current Rate
                        </label>
                        <select
                          className="form-control"
                          value={rate}
                          onChange={(event) => {
                            handleRateData(event);
                          }}
                          disabled
                        >
                          <option value={""}> Choose </option>
                          {metalRateOptions.map((item, index) => (
                            <option value={item._id}>{item.rate}</option>
                          ))}
                        </select>
                        {error && !rate && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the current rate
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                    
                      <div className="form-group">
                        <input
                          style={{ margin: "10px", transform: "scale(1.8)",}}
                          type="checkbox"
                          checked={productType === "latest" ? true : false}
                          onChange={(e) => setProductType(e.target.checked ? "latest" : "existing")}
                          aria-label="Checkbox for following text input"
                        />
                        <label
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Latest Product
                        </label>
                        <span className="text-danger text-gradient text-xs text-secondary m-2">
                          Note:
                        </span>
                        <span className="text-dark text-gradient text-xs text-secondary">
                          (Check the box if the product is latest)
                        </span>
                        {/* <div className="input-group-text"> */}

                        {/* <label
                            className="form-check-label"
                            for="flexCheckDefault"
                          >
                            Lastet product
                          </label> */}
                        {/* </div> */}
                        {/* <input
                          className="form-control"
                          type="text"
                          value={productType}
                          onChange={(e) => {
                            setProductType(e.target.value);
                          }}
                        />
                        {error && !productType?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the product type
                          </span>
                        )} */}
                      </div>
                    </div>
                  </div>

                  <div className="row"></div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          rows="5"
                          value={description}
                          onChange={(e) => {
                            setDescription(e.target.value);
                          }}
                        ></textarea>
                        {error && !description && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the description
                          </span>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Remarks
                        </label>
                        <textarea
                          className="form-control"
                          rows="5"
                          value={remark}
                          onChange={(e) => {
                            setRemark(e.target.value)
                          }}
                        ></textarea>
                      </div>
                    </div> */}
                  </div>
                  <div className="row">
                    <div className="text-end">
                      <button
                        type="button"
                        onClick={handleProsubmit}
                        className="btn btn-primary btn-sm ms-auto mt-5"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  );
}
export default AddProducts
